import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch City List
export const fetchCityList = createAsyncThunk(
  "city/fetchCityList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/location/panel/CityList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add City
export const addCityList = createAsyncThunk(
  "city/addCityList",
  async (newCityData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/CityList", newCityData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update City
export const updateCityList = createAsyncThunk(
  "city/updateCityList",
  async (cityData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/CityList", cityData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// City Slice
const citySlice = createSlice({
  name: "city",
  initialState: {
    cityList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchCityList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCityList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cityList = action.payload;
      })
      .addCase(fetchCityList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Add
      .addCase(addCityList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCityList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addCityList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Update
      .addCase(updateCityList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateCityList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateCityList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = citySlice.actions;
export default citySlice.reducer;
